import { render, staticRenderFns } from "./PayByText.vue?vue&type=template&id=5b282868&"
import script from "./PayByText.vue?vue&type=script&lang=ts&"
export * from "./PayByText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports